import store from '../store/store';
import { mutatorAction } from 'satcheljs';
/**
 *  Called when we click on time increment radio box, updates the new value in appearance option store
 *  @timeIncrement: new value for time increment setting
 */
export default mutatorAction('selectTimeIncrementOption', function selectTimeIncrementOption(timeIncrement) {
    var optionState = store();
    optionState.timeIncrement = timeIncrement;
});
//# sourceMappingURL=selectTimeIncrementOption.js.map